import { ResourceRegionType } from '#shared';

export const surgeonLabelsMap: Record<ResourceRegionType, string[]> = {
  [ResourceRegionType.West]: ['WE'],
  [ResourceRegionType.East]: ['NE', 'SE'],
  [ResourceRegionType.North]: ['MW'],
  [ResourceRegionType.South]: ['TX'],
};
